import moment from 'moment';

export default function commentLongTime(time: string) {
  return moment(time).format('MMM DD, YYYY h:mm A');
}
